'use client'
import dynamic from 'next/dynamic'

// `dynamic()` only code-splits client components when it is called from a client
// module. The slice registry calls it from the server, which puts every slice's
// dependencies into every page's bundle. Loading the forms from here keeps zod,
// react-hook-form, the resolver and axios out of pages that have no form.
const loading = () => <div className="min-h-[420px]" aria-busy="true" />

export const LazyContact = dynamic(() => import('../Contact/Contact').then((m) => m.Contact), { loading })
export const LazyDemo = dynamic(() => import('../Demo/Demo').then((m) => m.Demo), { loading })
